import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    marginTop: theme.spacing(4),
    width: '100%'
  },
  subtitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(1)
  },
  sectionSubtitle: ({ mode }) => ({
    fontSize: 10,
    fontWeight: 600,
    textTransform: 'uppercase',
    color: mode === 'light' ? theme.colorPalette.green_75 : theme.colorPalette.beige_60,
    margin: 0
  }),
  totalLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  totalText: ({ mode }) => ({
    fontSize: 10,
    fontWeight: 600,
    color: mode === 'light' ? theme.colorPalette.beige_75 : theme.colorPalette.beige_60
  }),
  totalCount: ({ mode }) => ({
    fontSize: 10,
    color: mode === 'light' ? theme.colorPalette.green_75 : theme.colorPalette.beige_25,
    fontWeight: 600
  }),
  bannerContainer: ({ mode }) => ({
    width: '100%',
    padding: theme.spacing(2),
    backgroundColor: mode === 'light' ? theme.colorPalette.beige_25 : theme.colorPalette.green_75_op_40,
    borderRadius: theme.sizes.roundCorners,
    margin: theme.spacing(1.25, 0)
  }),
  noItemsBanner: {
    textAlign: 'center'
  },
  noItemsTitle: ({ mode }) => ({
    fontSize: 14,
    fontWeight: 'normal',
    margin: theme.spacing(1, 0),
    color: mode === 'light' ? theme.colorPalette.green_90 : theme.colorPalette.beige_50
  }),
  noItemsSubtitle: ({ mode }) => ({
    fontSize: 10,
    margin: theme.spacing(0.5, 0),
    color: mode === 'light' ? theme.colorPalette.green_80 : theme.colorPalette.beige_25
  }),
  contentContainer: ({ mode }) => ({
    width: '100%',
    backgroundColor: mode === 'light' ? theme.colorPalette.beige_40 : theme.colorPalette.green_90,
    border: mode === 'light' ? `1px solid ${theme.colorPalette.white}` : 'none',
    borderRadius: mode === 'light' ? theme.sizes.roundCorners : 0,
    padding: mode === 'light' ? theme.spacing(2, 4) : 0
  })
});

export default makeStyles(styles);
